// require('./libraries/uikit/uikit.js');
import homeBanner from './components/banner/home-banner.js';
require('./components/swiper/swiper.js');
require('./components/general/general.js');
require('./components/general/new-file-handlers.js');
require('./components/navigation/navigation.js');
import lazyLoad from './components/general/lazy-load.js';
import logoSlider from './components/general/logo-slider.js';

window.onload = function() {
    homeBanner();
    lazyLoad();
    logoSlider();
};